'use client';

import { Box, Card, Divider, Grid, Skeleton } from '@mantine/core';

export function NewsListNewsItemSkeleton() {
  return (
    <Card withBorder p={0} mb={10}>
      <Grid>
        <Grid.Col span={{ base: 12, md: 4 }} style={{ display: 'flex', width: '100px' }} p={0}>
          <Skeleton height={250} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 8 }} px={0} py={15} style={{ position: 'relative' }}>
          <Skeleton height={22} width={240} ml={15} />
          <Skeleton height={18} width={110} ml={15} my={5} />
          <Box pt={10} pl={15} pb={50} pr={30} px={20}>
            <Skeleton height={18} />
            <Skeleton height={18} mt={5} />
            <Skeleton height={18} mt={5} />
          </Box>
          <Box style={{ position: 'absolute', bottom: 0, right: 0, width: '100%' }}>
            <Divider />
            <Grid pt={10} pb={15} px={20}>
              <Grid.Col span={{ base: 6 }}>
                <Skeleton height={18} width={130} />
              </Grid.Col>
              <Grid.Col span={{ base: 6 }}>
                <Skeleton style={{ float: 'right', marginRight: '15px' }} height={18} width={110} />
              </Grid.Col>
            </Grid>
          </Box>
        </Grid.Col>
      </Grid>
    </Card>
  );
}

export function NewsListNewsSkeleton() {
  return (
    <>
      <Box mb={10}>
        {Array(5)
          .fill(null)
          .map((skeleton, idx) => (
            <NewsListNewsItemSkeleton key={idx} />
          ))}
      </Box>
    </>
  );
}

export default NewsListNewsSkeleton;
